import { Modal, Button, Divider } from "antd";
import * as React from "react";
import { Layout, Input } from "antd";
import { Formik } from "formik";
import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { CustomSelect } from "../common/CustomSelect";

const { Content } = Layout;

export class EditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      selectedCourseType: "",
      errors: {
        selectedCourseType: "",
      },
    };
  }

  input;
  allCourses = [];

  async componentDidMount() {
    const { authToken, data, course_id } = this.props;

    let courseData = await listAllDropDownCourse(authToken, 0, 1000000);

    if (courseData.data && courseData.data.length >= 1) {
      courseData.data.forEach((data) => {
        this.allCourses.push({
          value: data._id,
          label: data.name,
        });
      });
    }

    this.setState({
      selectedCourseType:
        data.courseData && data.courseData[0] && data.courseData[0]._id
          ? data.courseData[0]._id
          : "",
    });
  }

  validateForm = (values) => {
    const { selectedCourseType } = this.state;

    const errors = {};

    console.log("Validating form -- ", values);

    if (!values.name) {
      errors.name = "Name is required";
    }

    if (!selectedCourseType) {
      errors.selectedCourseType = "Please select course";
    }

    console.log("Validating errors -- ", errors);
    return errors;
  };

  handleSubmit(values, action) {
    const { selectedCourseType } = this.state;
    const { data } = this.props;

    values.topic_id = data._id;
    values.course_id = selectedCourseType;
    values.is_module = true;

    this.props.onSubmit(values);

    this.setState({
      visible: false,
    });
  }

  changeCourse = (value) => {
    this.setState({
      selectedCourseType: value,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  isChanged = (values) => {
    const { data } = this.props;
    const initialCourseId = data.courseData && data.courseData[0] && data.courseData[0]._id
      ? data.courseData[0]._id
      : "";

    if (values.name !== data.name) return true;
    if (this.state.selectedCourseType !== initialCourseId) return true;

    return false;
  };

  render() {
    const { primaryColor, course_id } = this.props;
    const { selectedCourseType } = this.state;

    return (
      <div>
        <Formik
          initialValues={{
            name: this.props.data.name,
          }}
          validate={this.validateForm}
          onSubmit={this.handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => {
            return (
              <div>
                <div className="formik-field_wrap">
                  <div className="formik-field-left">
                    Name
                    <Input
                      id="name"
                      placeholder="Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.name && touched.name ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.name}
                      </p>
                    ) : null}
                  </div>

                  <div className="formik-field-right">
                    Course
                    <CustomSelect
                      style={{ width: "100%" }}
                      onChange={(value) => this.changeCourse(value)}
                      placeholder="Select Course"
                      showSearch={true}
                      disabled={course_id ? true : false}
                      value={selectedCourseType}
                      options={this.allCourses}
                    />
                    {errors.selectedCourseType ? (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          margin: "0",
                        }}
                      >
                        {errors.selectedCourseType}
                      </p>
                    ) : null}
                  </div>
                </div>

                <Button
                  type="primary"
                  disabled={!this.isChanged(values)}
                  style={{
                    marginTop: "19px",
                    background: this.isChanged(values) ? "#5C6AC4" : "#f5f5f5",
                    color: this.isChanged(values) ? "#fff" : "rgba(0, 0, 0, 0.25)",
                    borderColor: this.isChanged(values) ? "#5C6AC4" : "#d9d9d9",
                  }}
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </div>
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(withRouter(EditForm));
